// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1118":"afa2b15c","4839":"afa2b15c","7599":"afa2b15c"}[chunkId] + ".chunk.css";
};